import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteCameraFailed, deleteCameraSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteCamera(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/camera/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteCameraSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteCameraFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteCameraFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
